import { createMultipleItemResultNotificationValues } from '~commonInfra/contentActions/ActionMessages';
import { ContentActionNotification} from '~commonInfra/contentActions/ContentActionNotification';
import {
  IErrorItem,
  MultipleItemResult
} from '~commonInfra/contentActions/MultipleItemResult';
import { openReactConfirmationDialog } from '~commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { CommonErrorCode } from '~commonInfra/utils/ErrorCodes';
import { Set } from '~commonInfra/utils/Set';

import { Messages } from '../../codegen/Localize';
import { L10n } from '../../commonInfra/L10n/L10n';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { ISubscriptionInfo } from '../models/ISubscriptionInfo';
import { Subscriptions } from '../models/Subscriptions';

function deleteSubscriptions(subscriptions: Set<ISubscriptionInfo>): Promise<IResult> {

  let description: string;
  if(subscriptions.size() === 1) {
    const sub = subscriptions.first();
    description = Messages.confirmUnsubscribeSubscription({ TARGET_NAME: L10n.elideIfLong(sub.targetName) });
  } else {
    description = Messages.confirmUnsubscribeSubscriptions({SUBSCRIPTION_COUNT: subscriptions.size(), SUBSCRIPTION_COUNT_LOC: L10n.localizedCount(subscriptions.size()) });
  }

  const dialogInstance = openReactConfirmationDialog<string[], IResult>({
    title: Messages.unsubscribe(),
    message: description,
    actionName: Messages.confirmUnsubscribeButton({ ITEM_COUNT: subscriptions.size(), ITEM_COUNT_LOC: L10n.localizedCount(subscriptions.size()) }),
    isActionDelete: true,
    action: () => Subscriptions.del(subscriptions.keys()),
    paramsForAction: undefined,
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IResult) => {
    const notification =
      createMultipleItemResultNotificationValues(
        new MultipleItemResult(subscriptions, result),
        {
          describeSuccessSummary: (successCount: number) =>
            Messages.deleteSubscriptionsSuccess({ ITEM_COUNT: successCount, ITEM_COUNT_LOC: L10n.localizedCount(successCount) }),

          describeErrorSummary: (errorCount: number) =>
            Messages.deleteSubscriptionsError({ ERROR_COUNT: errorCount, ERROR_COUNT_LOC: L10n.localizedCount(errorCount) }),

          describeErrorDetail: (errorItem: IErrorItem<ISubscriptionInfo>) => {
            return {
              itemName: errorItem.item.subject,
              errorMessage: errorMessageFor(errorItem)
            };
          }
        });

    ContentActionNotification.displayItemizedToastsForResult(notification);
  });

  return Promise.resolve(dialogInstance.result);
}

function errorMessageFor(errorItem: IErrorItem<ISubscriptionInfo>) {
  switch (errorItem.error.code) {
    case CommonErrorCode.SubscriptionNotFound:
      return Messages.errorSubscriptionNotFound({ SUBSCRIPTION_NAME: L10n.elideIfLong(errorItem.item.subject) });
    default:
      return Messages.errorUnknown();
  }
}

export const DeleteSubscriptionsAction = {
  deleteSubscriptions
};
